




























































































import { Component, Prop, Vue } from "vue-property-decorator";
import AllConfigurationImages from "@/components/app/images/administration/all-configuration-images.vue";
import { downloadImage } from "@/services/getImage";
import { Cropper } from "vue-advanced-cropper";
import StandartModal from "@/components/app/standart-modal.vue";

import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { deleteImages } from "@/api/delite/delite-element";
import { pics } from "@/config/host.config";

@Component({
  components: {
    StandartModal,
    AllConfigurationImages,
    Cropper,
  },
})
export default class BackgroundConfigMobile extends Vue {
  @Prop({ type: String, default: "" }) image!: string;
  @Prop({ type: String, default: "" }) folder!: string;

  images: Array<string> = [];
  background = this.image;
  file: null | File = null;
  fullFile: null | File = null;
  id = "";

  $refs!: {
    file: HTMLInputElement;
  };

  isError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  async makeActive(id: string): Promise<void> {
    this.id = id;
    downloadImage(pics.download, id, this.folder)
      .then((image: Blob) => {
        this.background = URL.createObjectURL(new Blob([image]));
      })
      .catch(() => {
        this.isError();
      });
  }

  isUpload(): void {
    this.fullFile = this.$refs.file.files ? this.$refs.file.files[0] : null;
    if (this.fullFile)
      this.background = URL.createObjectURL(new Blob([this.fullFile]));
  }

  async isOk(): Promise<void> {
    if (!this.file) {
      this.isError();
      return;
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      params: {
        path: this.folder,
        name: this.id ? true : false,
        poster_name: this.id ? this.id : "",
      },
    };
    const uri = pics.upload;
    const formData: FormData = new FormData();
    formData.append("poster", this.file);

    try {
      const res = await this.$axios.post(uri, formData, config);
      if (res.status === 200) {
        this.$emit("changeBackground", this.id ? this.id : res.data);

        if (!this.fullFile) return;
        const full = new File([new Blob([this.fullFile])], res.data, {
          type: "img/jpg",
        });
        const fullformData: FormData = new FormData();
        fullformData.append("poster", full);
        config.params.name = true;
        config.params.poster_name = res.data;
        config.params.path = config.params.path + "/full";
        await this.$axios.post(uri, fullformData, config);
      }
    } catch (error) {
      this.isError();
    }
  }

  isChange({ canvas }: any): void {
    const imageDataUrl = canvas.toDataURL("img/jpg");
    const arr = imageDataUrl.split(",");
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    this.file = new File([u8arr], "mobile-bg.jpg", { type: "img/jpg" });
  }

  deleteBgImages(id: string): void {
    deleteImages(id, this.folder)
      .then(() => {
        this.images.splice(this.images.indexOf(id), 1);
      })
      .then(() => {
        deleteImages(id, this.folder + "/full");
      });
  }

  async getImages(path: string): Promise<Array<string>> {
    const uri = pics.download;
    const config: AxiosRequestConfig = {
      params: { path },
    };
    return new Promise<Array<string>>((res, rej) => {
      this.$axios
        .get(uri, config)
        .then((imgs: AxiosResponse<Array<string> | string>) => {
          if (imgs.status === 200 && imgs.data != "Папка не найдена")
            res(imgs.data as Array<string>);
        })
        .catch((e: AxiosError) => {
          rej(e);
        });
    });
  }

  createImageList(): void {
    this.getImages(this.folder).then((imgs: Array<string> | string) => {
      if (imgs != "Папка не найдена") this.images = imgs as Array<string>;
      const i = this.images.findIndex((e) => e == "full");
      this.images.splice(i, 1);
    });
  }

  mounted(): void {
    this.createImageList();
  }
}
